import React from 'react';

/**
 * @description This component is used to convert spaces to nbsp around the numeric value
 */
export const NbspAroundNumber = ({ message, numericValue }: { message: string; numericValue: number }) => {
  const rxTemplate = `\
^\
(?<head>.*?)\
(?<spaceBefore>\\s+)?\
(?<matchedValue>${String(numericValue).replace('.', '\\.')})\
(?<spaceAfter>\\s+)?\
(?<tail>.*)\
$\
`;
  const matchingGroup = message.match(new RegExp(rxTemplate))?.groups;

  if (!matchingGroup || !matchingGroup.matchedValue) {
    return <>{message}</>;
  }

  const { head, matchedValue, spaceAfter, spaceBefore, tail } = matchingGroup;

  return (
    <>
      {head}
      {spaceBefore == null ? null : <>&nbsp;</>}
      {matchedValue}
      {spaceAfter == null ? null : <>&nbsp;</>}
      {tail}
    </>
  );
};
